export default __webpack_public_path__ + "static/media/Freebooter's Boots of the Primeval.6159b9b1.jpg";